import * as React from 'react'
import '../../styles/buttons.css'

export type LogoutProps = {
  logoutHandler: () => void
  buttonStyle: string
}

const Logout = (props: LogoutProps): JSX.Element => {
  const { buttonStyle, logoutHandler } = props
  return (
    <button
      onClick={() => {
        logoutHandler()
      }}
      className={buttonStyle}
    >
      Logout
    </button>
  )
}

export default Logout
